export {
  RecentEditHighlights,
  type RecentEditHighlightsProps,
} from "@agent-native/toolkit/collab-ui";
